import { createReducer, on } from '@ngrx/store';

import { logout } from '../user/user.actions';
import { removeNotificationAction, showNotificationAction } from './notification.actions';
import { initialState, Notification, NotificationState } from './notification.state';

/**
 * Reducer for when the user logs out.
 */
const onLogout = on(logout, () => ({ ...initialState }));

/**
 * Called when we're going to show a notification
 */
const onShowNotification = on(showNotificationAction, (state: NotificationState, action) => {
	const newState = {
		...state,
		notifications: state.notifications.slice(0),
	};

	const { dialogType, buttonLabelCancel, buttonLabel, message, title, buttonColor, buttonColorCancel, onClose } =
		action;

	const notification: Notification = {
		dialogType,
		buttonLabel,
		buttonLabelCancel,
		buttonColor,
		buttonColorCancel,
		onClose,
		title,
		message,
	};

	if (action.inputField) {
		notification.inputField = action.inputField;
	}

	if (action.hideCancelButton) {
		notification.hideCancelButton = action.hideCancelButton;
	}

	if (!newState.current) {
		newState.current = notification;
	} else {
		newState.notifications.push(notification);
	}

	return newState;
});

/**
 * Called when closing a notification
 */
const onRemoveNotification = on(removeNotificationAction, (state: NotificationState, action) => {
	const newState = {
		...state,
		notifications: state.notifications.slice(0),
	};

	newState.current = null;

	if (newState.notifications?.length) {
		newState.current = newState.notifications.shift();
	}

	return newState;
});

export const notificationReducer = createReducer(initialState, onLogout, onShowNotification, onRemoveNotification);
